// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { i18n, changeLocalization } from './i18n';
import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import Treeselect from '@riophae/vue-treeselect';
import App from './App';
import router from './router';
import CustomFilter from './plugins/CustomFilter';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import AuthenticationService from './services/AuthenticationService';

window._ = require('lodash');

Vue.use(BootstrapVue);
Vue.use(VeeValidate,{ errorBagName: 'validationErrors', fieldsBagName: 'validationFields' });
Vue.use(CustomFilter);

Vue.component('treeselect', Treeselect);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.config.productionTip = process.env.NODE_ENV === 'production';

function startApp() {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      template: '<App/>',
      components: { App },
      i18n
    });
}

changeLocalization('en-GB')
  .then(_ => { startApp(); })
  .catch(_ => { startApp(); });

// See also https://router.vuejs.org/guide/advanced/lazy-loading.html
const applyDefaultStyle = () => import('./../scss/style-APP_TARGET.scss')

let styleHook = router.beforeEach((to, from, next) => {
  // Unregister hook
  styleHook();

  // Use customized theme if generic platform and authenticated client user
  if (APP_TARGET === '' && AuthenticationService.isAuthenticated && !AuthenticationService.isMSMUser)
  {
    let stylesheetLink = document.createElement('link');
    stylesheetLink.rel = 'stylesheet';
    stylesheetLink.href = `${process.env.BASE_URL}api/users/css?clientId=${AuthenticationService.localUserProfile.ClientId}`;
    stylesheetLink.onload = next;
    stylesheetLink.onerror = () => { 
      applyDefaultStyle().then(() => { next(); });
    };
    document.head.appendChild(stylesheetLink);
  }
  else
  {
    applyDefaultStyle().then(() => { next(); });
  }
});